import React from 'react';
import {
  arrayOf,
  bool,
  func,
  node,
  number,
  oneOfType,
  string
} from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../../../.internal/BaseComponent';
import Icon from '../../../../icon/Icon';
import StepControls from './components/step_controls/StepControls';

import './MultiStepContainer.scss';

export default class MultiStepContainer extends BaseComponent {
  render() {
    const {
      children,
      className,
      displayClose,
      labelNext,
      onNext,
      position,
      stepNumber,
      stepTotal
    } = this.props;

    const classNames = ClassNames([
      'multi-step-container',
      position,
      className
    ]);
    const arrowClassNames = ClassNames(['step-arrow', position]);

    return (
      <div className={classNames}>
        {displayClose && (
          <div className="step-close-container">
            <Icon className="step-close-button" icon="times" />
          </div>
        )}
        <div className={arrowClassNames} />
        <div className="step-content">{children}</div>
        <StepControls
          labelNext={labelNext}
          onNext={onNext}
          stepNumber={stepNumber}
          stepTotal={stepTotal}
        />
      </div>
    );
  }
}

MultiStepContainer.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  displayClose: bool.isRequired,
  labelNext: string.isRequired,
  onNext: func,
  stepNumber: number.isRequired,
  stepTotal: number.isRequired
};

MultiStepContainer.defaultProps = {
  children: null,
  onNext: undefined
};
